import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import {getImageUrl } from "../../utils";

const ImageDisplayModal = (props) => {
    const { show, close, currentService,handleDeleteMedia,removeURL } = props;

    return (
        <Modal show={currentService?.samples?.length > 0 ? show :false } centered size="bg">
            <div class="modal-dialog-centered">
                <div class="">
                    <div class="modal-header">
                        <h5 class="modal-title">View Samples</h5>
                        <button type="button" class="btn-close" onClick={close}></button>
                    </div>
                    <div class="modal-body">
                        <div class="px-2 ps-0">
                            <div class="row">
                                {currentService?.samples?.map((img) => {
                                    return (
                                      img?.uploadSamples && (<div class="col-6">
                                            <div class="imgWrap">
                                                <div class="imgWrap-opt">
                                                    <a onClick={()=>handleDeleteMedia(img,currentService)}>
                                                        <b class="icon-bin"></b>
                                                    </a>
                                                    <a>
                                                        <b class="icon-fullscreen"></b>
                                                    </a>
                                                </div>
                                                <img src={getImageUrl(img?.uploadSamples)} alt="#" />
                                            </div>
                                        </div>)
                                    );
                                })}
                                {currentService?.samples?.map((url) => {
                                    return (
                                        url?.url && (<div class="col-6">
                                            <div class="urlWrap">
                                                <b class="icon-link urlWrap-icon"></b>
                                                <p class="urlWrap-url">{url?.url}</p>
                                                <div class="urlWrap-opt">
                                                    <a onClick={()=>removeURL(url,currentService)}>
                                                        <b class="icon-bin"></b>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
ImageDisplayModal.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    currentService: PropTypes.object,
    handleDeleteMedia:PropTypes.func,
    removeURL:PropTypes.func,
};

ImageDisplayModal.defaultProps = {
    show: false,
    close: () => null,
    currentService: {},
    handleDeleteMedia:() => null,
    removeURL:()=>null,

};
export default ImageDisplayModal;
